<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        <a href="#" @click.prevent="$router.push({ name: 'student-profile' })" class="mr-2">
          <i class="fas fa-arrow-left"></i>
        </a>
        {{
          $t('school.academic.operation.profile_mgt.studentProfile.pageTitle')
        }}
      </h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t(
            'school.academic.operation.profile_mgt.studentProfile.pageTitle'
          ),
          href: '/student-profiles'
        },
        {
          text: $t('add_new'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <!-- <ts-card-wrapper> -->
      <form-wizard :title="''" :subtitle="''" finishButtonText="Save" color="#348fe2" errorColor="red" ref="wizard"
        @on-complete="onComplete">
        <tab-content style="min-height: 370px !important;" :title="$t(
          'school.academic.operation.profile_mgt.studentProfile.profileInformation'
        )
          " icon="fas fa-user-graduate" :before-change="() => validateStep('profile-information')">
          <profile-information ref="profile-information" v-model="model" :validate="errors" :clear="clear" />
        </tab-content>
        <tab-content style="min-height: 370px !important;" :title="$t('school.academic.operation.profile_mgt.studentProfile.contact')
          " icon="fas fa-phone-volume">
          <contact v-model="model" :validate="errors" :clear="clear" />
        </tab-content>
        <tab-content style="min-height: 370px !important;" :title="$t(
          'school.academic.operation.profile_mgt.studentProfile.schoolInformation'
        )
          " icon="fas fa-school">
          <school-information v-model="model" :validate="errors" :clear="clear" />
        </tab-content>
        <tab-content style="min-height: 370px !important;" :title="$t('school.academic.operation.profile_mgt.studentProfile.address')
          " icon="fas fa-map-marker-alt">
          <address-form v-model="model" :validate="errors" :clear="clear" />
        </tab-content>
        <tab-content style="min-height: 370px !important;" :title="$t('school.academic.operation.profile_mgt.studentProfile.discount')
          " icon="fas fa-percent">
          <discount v-model="model" :validate="errors" :clear="clear" />
        </tab-content>
        <tab-content style="min-height: 370px !important;" :title="$t(
          'school.academic.operation.profile_mgt.studentProfile.bankAccount'
        )
          " icon="fas fa-money-check-alt">
          <bank-account-info v-model="model" :validate="errors" :clear="clear" />
        </tab-content>

        <template slot="footer" slot-scope="props">
          <div class="wizard-footer-left">
            <wizard-button v-if="props.activeTabIndex > 0 && !props.isLastStep" @click.native="props.prevTab()"
              :style="'background:#e2e2e2'">
              {{
                $t(
                  'school.academic.operation.profile_mgt.studentProfile.previous'
                )
              }}
            </wizard-button>
          </div>
          <div class="wizard-footer-right">
            <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right"
              :style="props.fillButtonStyle" :disabled="nextStep">
              <i class="fa fa-spinner spin mr-2" v-if="nextStep"></i>
              {{
                $t('school.academic.operation.profile_mgt.studentProfile.next')
              }}
            </wizard-button>
            <wizard-button v-else @click.native="onComplete" class="wizard-footer-right finish-button"
              :style="props.fillButtonStyle" :disabled="waiting">
              <i class="fa fa-spinner spin mr-2" v-if="waiting"></i>
              {{
                props.isLastStep
                  ? $t(
                    'school.academic.operation.profile_mgt.studentProfile.done'
                  )
                  : $t(
                    'school.academic.operation.profile_mgt.studentProfile.next'
                  )
              }}
            </wizard-button>
          </div>
        </template>
      </form-wizard>
      <!-- </ts-card-wrapper> -->
    </ts-card>
  </div>
</template>

<script>
import { FormWizard, TabContent, WizardButton } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import moment from 'moment'
// components
import ProfileInformation from './component/profile-information'
import SchoolInformation from './component/school-information'
import Contact from './component/contact'
import AddressForm from './component/address'
import Discount from './component/discount'
import BankAccountInfo from './component/bank-account-info'
import Compressor from 'compressorjs'

export default {
  name: 'studentProfileCreate',
  components: {
    FormWizard,
    TabContent,
    WizardButton,
    ProfileInformation,
    SchoolInformation,
    Contact,
    AddressForm,
    Discount,
    BankAccountInfo
  },
  data() {
    return {
      model: {
        first_name_kh: null,
        last_name_kh: null,
        first_name_en: null,
        last_name_en: null,
        gender: null,
        date_of_birth: null,
        place_of_birth: null,
        province_code: null,
        district_code: null,
        commune_code: null,
        village_code: null,
        street_no: null,
        house_no: null,
        phone: null,
        serial_finger_print_no: null,
        email: null,
        facebook_account: null,
        photo: null,
        ac_st_id: null,
        is_card_discount: false,
        card_discount_rate: null,
        is_till_further_notice: false,
        discount_expiry_date: null,
        discount_note: null,
        discount_by_staff_id: null,
        nationality: 33,
        religion: 1,
        registered_date: moment().format('DD-MM-YYYY'),
        changed_in_from_school: null,
        changed_in_from_school_type: null,
        current_school_another_program: null,
        current_school_another_program_type: null,
        linked_in: null,
        telegram: null,
        line: null,
        we_chart: null,
        emergency_contact_person: null,
        emergency_contact_relation: null,
        emergency_contact_phone: null,
        student_parent_id: null,
        inquiry_id: null,
        cpp_id: null,
        is_appear_other_branch: 0,
        class_id: null,
        banks: [],
        appear_other_branch_id: [],
        discount_by_sub_programs: [],
        is_external: false
      },
      errors: new Errors(),
      nextStep: false,
      waiting: false,
      clear: false
    }
  },
  methods: {
    ...mapActions('studentProfile', ['uploadPhoto']),
    validateStep(name) {
      var refToValidate = this.$refs[name]
      return refToValidate.validateForm()
    },

    async onComplete() {
      this.errors = new Errors()
      this.waiting = true
      if (
        this.model.photo instanceof File ||
        this.model.photo instanceof Blob
      ) {
        new Compressor(this.model.photo, {
          quality: 0.2,
          success: async result => {
            let formData = new FormData()
            formData.append('photo', result)
            let photo_path = await this.$store.dispatch(
              'studentProfile/uploadPhoto',
              formData
            )

            await this.$store
              .dispatch(
                'studentProfile/store',
                Object.assign({}, this.model, { photo: photo_path })
              )
              .then(response => {
                this.clearForm()
                this.clear = true
                this.$refs.wizard.reset()
                this.waiting = false
                this.$toasted.success(response.message)
                this.$router.push({ name: 'student-profile' })
              })
              .catch(error => {
                this.waiting = false
                this.errors = new Errors(error.errors)
                this.$toasted.error(error.message)
              })
          }
        })
      } else {
        this.$store
          .dispatch(
            'studentProfile/store',
            Object.assign({}, this.model, { photo: this.model.photo })
          )
          .then(response => {
            this.clearForm()
            this.clear = true
            this.$refs.wizard.reset()
            this.waiting = false
            this.$toasted.success(response.message)
            this.$router.push({ name: 'student-profile' })
          })
          .catch(error => {
            this.waiting = false
            this.errors = new Errors(error.errors)
            this.$toasted.error(error.message)
          })
      }
    },
    clearForm() {
      this.model = {
        first_name_kh: null,
        last_name_kh: null,
        first_name_en: null,
        last_name_en: null,
        gender: null,
        date_of_birth: null,
        place_of_birth: null,
        province_code: null,
        district_code: null,
        commune_code: null,
        village_code: null,
        street_no: null,
        house_no: null,
        phone: null,
        serial_finger_print_no: null,
        email: null,
        facebook_account: null,
        photo: null,
        ac_st_id: null,
        is_card_discount: false,
        card_discount_rate: null,
        is_till_further_notice: false,
        discount_expiry_date: null,
        discount_note: null,
        discount_by_staff_id: null,
        nationality: 33,
        religion: 1,
        registered_date: moment().format('DD-MM-YYYY'),
        changed_in_from_school: null,
        changed_in_from_school_type: null,
        current_school_another_program: null,
        current_school_another_program_type: null,
        linked_in: null,
        telegram: null,
        line: null,
        we_chart: null,
        emergency_contact_person: null,
        emergency_contact_relation: null,
        emergency_contact_phone: null,
        student_parent_id: null,
        inquiry_id: null,
        cpp_id: null,
        class_id: null,
        appear_other_branch_id: [],
        discount_by_sub_programs: [],
      }
    }
  }
}
</script>
